/**
 * 新增知识教育视频模板合集
 *
 * 23 个全新模板，覆盖 6 大类别：
 *
 * 1. 基础学科与学术教育 (6)
 *    - ThermodynamicsAnimation · 热力学四大定律
 *    - SetTheoryAnimation · 集合论可视化
 *    - LiteraryRhetoricAnimation · 文学修辞手法
 *    - OrganicChemistryAnimation · 有机化学基础
 *    - LinearAlgebraAnimation · 线性代数
 *    - GeneticInheritanceAnimation · 孟德尔遗传定律
 *
 * 2. 职业技能与实操技术 (5)
 *    - GitWorkflowAnimation · Git 工作流详解
 *    - SystemDesignAnimation · 系统设计架构图
 *    - AgileMethodAnimation · 敏捷开发 Scrum
 *    - DataCleaningAnimation · 数据清洗全流程
 *
 * 3. 硬核科普与通识教育 (3)
 *    - CRISPRGeneEditAnimation · CRISPR 基因编辑
 *    - StringTheoryAnimation · 弦理论入门
 *    - MicrobiomeAnimation · 人体微生物组
 *
 * 4. 泛知识与生活百科 (3)
 *    - TimeManagementAnimation · 艾森豪威尔矩阵
 *    - ErgonomicsAnimation · 人体工程学指南
 *    - FoodSafetyAnimation · 食品安全必知
 *
 * 5. 思维启发与个人成长 (6)
 *    - SecondBrainAnimation · 第二大脑 CODE
 *    - FeynmanTechniqueAnimation · 费曼学习法
 *    - MentalModelAnimation · 核心心智模型
 *    - FirstPrinciplesThinkingAnimation · 第一性原理思维
 *    - EightyTwentyRuleAnimation · 帕累托 80/20
 *    - DecisionMatrixAnimation · 决策矩阵
 *
 * 6. 心理学 (1)
 *    - DunningKrugerEffectAnimation · 达克效应
 *
 * @date 2026-03-23
 */

import React from 'react';
import { Composition } from 'remotion';

// 1. 基础学科与学术教育
import { ThermodynamicsAnimation } from '../templates/academic/ThermodynamicsAnimation';
import { SetTheoryAnimation } from '../templates/academic/SetTheoryAnimation';
import { LiteraryRhetoricAnimation } from '../templates/academic/LiteraryRhetoricAnimation';
import { OrganicChemistryAnimation } from '../templates/academic/OrganicChemistryAnimation';
import { LinearAlgebraAnimation } from '../templates/academic/LinearAlgebraAnimation';
import { GeneticInheritanceAnimation } from '../templates/academic/GeneticInheritanceAnimation';

// 2. 职业技能与实操技术
import { GitWorkflowAnimation } from '../templates/skills/GitWorkflowAnimation';
import { SystemDesignAnimation } from '../templates/skills/SystemDesignAnimation';
import { AgileMethodAnimation } from '../templates/skills/AgileMethodAnimation';
import { DataCleaningAnimation } from '../templates/skills/DataCleaningAnimation';

// 3. 硬核科普与通识教育
import { CRISPRGeneEditAnimation } from '../templates/popular-science/CRISPRGeneEditAnimation';
import { StringTheoryAnimation } from '../templates/popular-science/StringTheoryAnimation';
import { MicrobiomeAnimation } from '../templates/popular-science/MicrobiomeAnimation';

// 4. 泛知识与生活百科
import { TimeManagementAnimation } from '../templates/life-knowledge/TimeManagementAnimation';
import { ErgonomicsAnimation } from '../templates/life-knowledge/ErgonomicsAnimation';
import { FoodSafetyAnimation } from '../templates/life-knowledge/FoodSafetyAnimation';

// 5. 思维启发与个人成长
import { SecondBrainAnimation } from '../templates/thinking/SecondBrainAnimation';
import { FeynmanTechniqueAnimation } from '../templates/thinking/FeynmanTechniqueAnimation';
import { MentalModelAnimation } from '../templates/thinking/MentalModelAnimation';
import { FirstPrinciplesThinkingAnimation } from '../templates/thinking/FirstPrinciplesThinkingAnimation';
import { EightyTwentyRuleAnimation } from '../templates/thinking/EightyTwentyRuleAnimation';
import { DecisionMatrixAnimation } from '../templates/thinking/DecisionMatrixAnimation';

// 6. 心理学
import { DunningKrugerEffectAnimation } from '../templates/psychology/DunningKrugerEffectAnimation';

export const NewKnowledgeCompositions: React.FC = () => {
  return (
    <>
      {/* ==================== 1. 基础学科与学术教育 ==================== */}

      <Composition
        id="ThermodynamicsAnimation"
        component={ThermodynamicsAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="SetTheoryAnimation"
        component={SetTheoryAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="LiteraryRhetoricAnimation"
        component={LiteraryRhetoricAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="OrganicChemistryAnimation"
        component={OrganicChemistryAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="LinearAlgebraAnimation"
        component={LinearAlgebraAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="GeneticInheritanceAnimation"
        component={GeneticInheritanceAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      {/* ==================== 2. 职业技能与实操技术 ==================== */}

      <Composition
        id="GitWorkflowAnimation"
        component={GitWorkflowAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="SystemDesignAnimation"
        component={SystemDesignAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="AgileMethodAnimation"
        component={AgileMethodAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="DataCleaningAnimation"
        component={DataCleaningAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      {/* ==================== 3. 硬核科普与通识教育 ==================== */}

      <Composition
        id="CRISPRGeneEditAnimation"
        component={CRISPRGeneEditAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="StringTheoryAnimation"
        component={StringTheoryAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="MicrobiomeAnimation"
        component={MicrobiomeAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      {/* ==================== 4. 泛知识与生活百科 ==================== */}

      <Composition
        id="TimeManagementAnimation"
        component={TimeManagementAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="ErgonomicsAnimation"
        component={ErgonomicsAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="FoodSafetyAnimation"
        component={FoodSafetyAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      {/* ==================== 5. 思维启发与个人成长 ==================== */}

      <Composition
        id="SecondBrainAnimation"
        component={SecondBrainAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="FeynmanTechniqueAnimation"
        component={FeynmanTechniqueAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="MentalModelAnimation"
        component={MentalModelAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="FirstPrinciplesThinkingAnimation"
        component={FirstPrinciplesThinkingAnimation}
        durationInFrames={960}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="EightyTwentyRuleAnimation"
        component={EightyTwentyRuleAnimation}
        durationInFrames={1080}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      <Composition
        id="DecisionMatrixAnimation"
        component={DecisionMatrixAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

      {/* ==================== 6. 心理学 ==================== */}

      <Composition
        id="DunningKrugerEffectAnimation"
        component={DunningKrugerEffectAnimation}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />

    </>
  );
};
